module.exports = __webpack_public_path__ + "static/media/ชื่ออาณาจักร.bba0f9cf.jpg";